import { toHumanFriendlyFormat } from '@/util/date'

const dayList = [
  { id: 2, label: '月曜日' },
  { id: 3, label: '火曜日' },
  { id: 4, label: '水曜日' },
  { id: 5, label: '木曜日' },
  { id: 6, label: '金曜日' },
  { id: 7, label: '土曜日' },
  { id: 1, label: '日曜日' },
]
export default {
  /**
   * 期間条件標準フォーマット
   *
   * 日 / 週 / 月 どれが選択されているか、と開始・終了日を保持します。
   * 期間の種別が週や月であっても、最終的な開始・終了の日付で管理します。
   */
  get() {
    return {
      /**
       * 期間種別（日:d / 週:w / 月:m）
       */
      termType: 'w',
      /**
       * 開始日
       */
      dateFrom: undefined,
      /**
       * 終了日
       */
      dateTo: undefined,
      /**
       * 入力エラー
       */
      errors: [],
      /**
       * ～から、～まで
       */
      weekType: 'COUNT_FROM',
      /**
       * 日付選択か曜日選択か
       */
      selectType: 'date',
      /**
       * 選択した日付のリスト
       * [1, 11, 21]
       */
      selectedDates: [],
      /**
       * 選択した曜日のリスト
       * [0, 1, 2]
       */
      selectedDays: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(term) {
    return {
      termType: term.termType,
      dateFrom: term.dateFrom,
      dateTo: term.dateTo,
      weekType: term.weekType,
      selectType: term.selectType,
      selectedDates: term.selectedDates,
      selectedDays: term.selectedDays,
    }
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, term) {
    applyTo.termType = term.termType
    applyTo.dateFrom = term.dateFrom
    applyTo.dateTo = term.dateTo
    applyTo.weekType = term.weekType || 'COUNT_FROM'
    applyTo.selectType = term.selectType || 'date'
    applyTo.selectedDates = term.selectedDates || []
    applyTo.selectedDays = term.selectedDays || []
  },
  summaryText(term) {
    if (term.termType === 'select') {
      return (
        toHumanFriendlyFormat(term.dateFrom) +
        ' ～ ' +
        toHumanFriendlyFormat(term.dateTo) +
        ' (' +
        (term.selectType === 'date'
          ? term.selectedDates.map(m => m + '日')
          : term.selectedDays.map(m => {
              const day = dayList.find(f => f.id === m)
              return day.label
            })) +
        ')'
      )
    } else {
      return (
        toHumanFriendlyFormat(term.dateFrom) +
        ' ～ ' +
        toHumanFriendlyFormat(term.dateTo)
      )
    }
  },
}
